import {
  BlockchainTokensType,
  type BlockchainNftPoolConfigType,
} from "../../types";
import { ChainId } from "../../chain-specific";
import type { Hex } from "viem";

// Represents the index of the staking pool starting from 1
export enum PoolId {
  POOL1 = 1,
  POOL2 = 2,
  POOL3 = 3,
  POOL4 = 4,
  POOL5 = 5,
  POOL6 = 6,
  POOL7 = 7,
  // Add more pool IDs as necessary
}

export const poolNum = Object.values(PoolId).filter(
  (value) => typeof value === "number"
).length;

export const DEFAULT_ADMIN_ROLE: Hex =
  "0x0000000000000000000000000000000000000000000000000000000000000000";

// Pool Configuration Object
export const POOL_CONFIG: BlockchainNftPoolConfigType = {
  [ChainId.SHIBARIUM]: {
    [PoolId.POOL1]: {
      noEnumerable: true,
      pid: 1,
      chainId: ChainId.SHIBARIUM,
      name: "Shiboshis for CHEWY",
      contractType: "thirdweb",
      address: "0x93c0CD0194412Da7362dD737E8561cC4D33b7CDB",
      market1: "https://opensea.io/collection/theshiboshis",
      market2:
        "https://app.withmantra.com/market/collection/0x0c7245d5aaf71aa19b310ad65599b8e36501185c?chain_id=109",
      marketplaces: [],
      nftAddress: "0x0c7245d5AAf71aA19b310ad65599b8E36501185C",
      nftMaxSupply: 10000,
      nftSymbol: "SBSH",
      nftName: "SHIBOSHIS",
      nftUri: "https://chewy.build/nft/boshi/images/",
      nftExt: ".png",
      previewIds: [669],
      rewardSymbol: "CHEWY",
      rewardName: "ChewySwap",
      rewardLogo:
        "https://github.com/ChewySwap/chewy-tokenlist/blob/main/tokens/chewy.webp?raw=true",
      rewardAddress: "0x2761723006d3Eb0d90B19B75654DbE543dcd974f",
      rewardPair: "0x324EEf33AF720cE44DEAB7e32F4367a82b4eA43b",
      rewardDecimals: 18,
      rewardDecimalPlaces: 4,
      rewardPriceDecimalPlaces: 3,
      aboutTitle1: "What are SHIBOSHIS?",
      aboutContent1:
        "SHIBOSHIS are 10,000 lovable Shiba Inu generated Non Fungible Tokens (NFTS) eternally written on the Ethereum blockchain. These Shibs have varying traits that make each unique and collectible (for instance Laser Eyes or Party Hat). Furthermore, each trait corresponds to an enhancement of the base ShibaStrength of the Shiboshi in our upcoming Shiboshi Game. You'll be able to purchase, and trade these SHIBOSHIS here and at ShibaSwap without fees. These are the official SHIBOSHIS of the Shiba Inu decentralized community as seen on Forbes, Wall St. Journal, Fortune, CNN, MSNBC and just about everywhere else. Beware of scams.",
      aboutTitle2: "Stake your SHIBOSHIS to earn CHEWY Rewards!",
      aboutContent2:
        "For the first time ever on Shibarium - stake your SHIBOSHI's to earn tasty CHEWY rewards! SHIBOSHIS must first be bridged from Mainnet (Ethereum) to Shibarium in order to stake. Find link to official NFT bridge above.",
    },
  },
  [2000]: {},
  // Repeat for other ChainId values as necessary
};
